import {useChatWithUser} from './useChatWithUser';

export function useChatWithUserPathname(userId) {
    const chatSession = useChatWithUser(userId);

    return ['.', 'chats', chatSession?.id ?? `new?participant=${userId}`].join('/');
}
